<mat-form-field
  *ngIf="input as input"
  class="custom-mat-form-field w-full custom-border-bottom custom-line-ripple">
  <input
    matInput
    type="text"
    [placeholder]="placeholder"
    [formControl]="input">

  <button
    matSuffix
    mat-icon-button
    aria-label="Clear"
    [class.hidden]="!input.value"
    (click)="input?.setValue(''); clear.emit()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="input.invalid && errorMessage">
    {{ errorMessage }}
  </mat-error>
</mat-form-field>
